import { render, staticRenderFns } from "./UserCompanyPage.vue?vue&type=template&id=ed3b134e&"
import script from "./UserCompanyPage.vue?vue&type=script&lang=js&"
export * from "./UserCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports